import { create } from 'zustand';

interface CollaborateStoreStatus {
  isAssist: boolean;
  setIsAssist: (isAssist: boolean) => void;
}

export const useCollaborateStore = create<CollaborateStoreStatus>((set, get) => ({
  isAssist: false,
  setIsAssist: (isAssist) => set({ isAssist }),
}));
